import { Tab, Tabs } from "@mui/material";
import { styles } from "../stylesRightSidebar";
import { FC } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "@/store/store";
import { setActiveTab } from "@/store/slice/rightSidebarSlice";

interface TabItem {
  label: string;
  value: string;
}

const TabNavigation: FC<{ tabs: TabItem[] }> = ({ tabs }) => {
  const dispatch = useDispatch();
  const activeTab = useSelector((state: RootState) => state.rightSidebar.activeTab);

  return (
    <Tabs
      value={activeTab}
      onChange={(_, value) => dispatch(setActiveTab(value))}
      sx={styles.tabsNavigation}
      variant="scrollable"
      scrollButtons={false}
      TabIndicatorProps={{
        sx: styles.tabsNavigationIndicator,
      }}
    >
      {tabs.map((tab) => (
        <Tab
          key={tab.value}
          label={tab.label}
          value={tab.value}
          sx={styles.tabsNavigationTab(activeTab, tab.value)}
          disableRipple
          disableFocusRipple
        />
      ))}
    </Tabs>
  );
};

export default TabNavigation;
